import { apiClient } from '@/api/client'
import type { GenerateResult, ReportFormat, ReportTarget, ReportTargetKind } from './types'

const BASE = '/portal/monthly-reports'

export async function fetchReportTargets(): Promise<ReportTarget[]> {
  const { data } = await apiClient.get<ReportTarget[]>(`${BASE}/api/v2/targets`)
  return data
}

export async function fetchYearsWithData(kind: ReportTargetKind, identifier: string): Promise<number[]> {
  const { data } = await apiClient.post<{ success: boolean; years: number[] }>(`${BASE}/years`, { kind, identifier })
  return data.years
}

export async function checkDataAvailability(params: {
  kind: ReportTargetKind
  identifier: string
  format: ReportFormat
  years: number[]
}): Promise<GenerateResult> {
  const { data } = await apiClient.post<GenerateResult>(`${BASE}/generate`, params)
  return data
}

export async function downloadReport(params: {
  kind: ReportTargetKind
  identifier: string
  format: ReportFormat
  years: number[]
}): Promise<{ blob: Blob; filename: string }> {
  const response = await apiClient.post(`${BASE}/download`, params, { responseType: 'blob' })
  const disposition = response.headers['content-disposition'] as string | undefined
  const match = disposition?.match(/filename="?([^"]+)"?/)
  const filename = match?.[1] ?? `report.${params.format}`
  return { blob: response.data as Blob, filename }
}
